module.exports = __webpack_public_path__ + "static/media/Telangana.64f6fafb.PNG";